export const types = {
  "ActiveCollab\\Module\\System\\Model\\Conversation\\OneToOneConversation": "OneToOneConversation",
  "ActiveCollab\\Module\\System\\Model\\Conversation\\GroupConversation": "GroupConversation",
  "ActiveCollab\\Module\\System\\Model\\Conversation\\ParentObjectConversation": "ParentObjectConversation",
  "ActiveCollab\\Module\\System\\Model\\Conversation\\OwnConversation": "OwnConversation",
  "ActiveCollab\\Module\\System\\Model\\Conversation\\GeneralConversation": "GeneralConversation",
};
